import { AiOutlineLoading3Quarters } from "react-icons/ai";

const ButtonLoader = () => {
  return (
    <AiOutlineLoading3Quarters
      className="h-[25px] w-[25px] font-extrabold text-inherit animate-spin m-[2px]"
    />
  );
};

export default ButtonLoader;